export default {
    index: "Willkommen",
    users: "Nutzer",
    organisations: "Organisationen",
    "settings-loginProviders": "Login Methoden"
}
